<template>
    <div style="margin-bottom: 10vh;">
        <ul style="list-style:none;margin:10px 0;">
            <li style="padding-bottom:12px;">
                <div>
                    <h3><a href="/static/Spring.pdf" target="_blank">Spring and Hibernate</a></h3>
                    <hr>
                    <p>
                        <b>Source : </b> Udemy
                        <br>
                        <b>Date : </b> 26th April, 2020
                        <br>
                    </p>
                </div>
            </li>
            <li style="padding-bottom:12px;">
                <div>
                    <h3><a href="/static/Kubernetes_Mastery.pdf" target="_blank">Kubernetes Mastery</a></h3>
                    <hr>
                    <p>
                        <b>Source : </b> Udemy
                        <br>
                        <b>Date : </b> 6th November, 2020
                        <br>
                    </p>
                </div>
            </li>

            <li style="padding-bottom:12px;">
                <div>
                    <h3><a href="/static/Docker_Mastery.pdf" target="_blank">Docker Mastery</a></h3>
                    <hr>
                    <p>
                        <b>Source : </b> Udemy
                        <br>
                        <b>Date : </b> 27th July, 2020
                        <br>
                    </p>
                </div>
            </li>


            <li style="padding-bottom:12px;">
                <div>
                    <h3><a href="/static/DevOps_Essentials.pdf" target="_blank">DevOps Essentials</a></h3>
                    <hr>
                    <p>
                        <b>Source : </b> Linux Academy
                        <br>
                        <b>Date : </b> 26th July, 2019
                        <br>
                    </p>
                </div>
            </li>
            <li style="padding-bottom:12px;">
                <div>
                    <h3><a href="/static/AWS_Essentials.pdf" target="_blank">AWS Essentials</a></h3>
                    <hr>
                    <p>
                        <b>Source : </b> Udemy
                        <br>
                        <b>Date : </b> 26th July, 2019
                        <br>
                    </p>
                </div>
            </li>
            <li style="padding-bottom:12px;">
                <div>
                    <h3><a href="/static/AWS_Concepts.pdf" target="_blank">AWS Concepts</a></h3>
                    <hr>
                    <p>
                        <b>Source : </b> Udemy
                        <br>
                        <b>Date : </b> 24th July, 2019
                        <br>
                    </p>
                </div>
            </li>
        </ul>
    </div>
</template>
<script>
export default {
    name: "Certificates"
};
</script>



// WEBPACK FOOTER //
// src/components/certificatesComponent.vue